export default __webpack_public_path__ + "static/media/spooky_hill_background_xl1.83703edb.jpg";